import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../..';
import { Title } from '../../Zemplin/General/Title';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';

interface Props {
  isOpen: boolean;
  description: any;
  condition?: string;
  forbiddenOrderUntilDate?: string;
}

function Description(props:Props) {
  const { description, isOpen, condition, forbiddenOrderUntilDate } = props;
  return (
    <>
      <Wrapper isOpen={isOpen}>
        {condition && condition !== '' && (
          <ConditionText>{condition}</ConditionText>
        )}

        {forbiddenOrderUntilDate?
          <ConditionText>{__("Produkt bude možné zakúpiť najskôr od")} {forbiddenOrderUntilDate}</ConditionText>
          :<></>
        }          

        {React.isValidElement(description) ? (
          description
        ) : description && description !== '' ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <StyledTitle>{__(`Žiadny popis produktu`)}</StyledTitle>
        )}
      </Wrapper>
    </>
  );
}

export const Wrapper = styled(FlexRowCenterVertical)<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (!isOpen ? 'none' : 'block')};
  padding: ${rem(56)} ${rem(232)};
  color: ${({ theme }) => theme.colors.textPrimary};

  ${({ theme }) => theme.mediab.l925`
    padding: 0;
    padding-top: ${rem(32)};
  `}

  img {
    object-fit: contain;
  }

  table {
    border-collapse: collapse;
    border: none;

    tr,
    td {
      border: none;
      padding: ${rem(14)} ${rem(16)};
    }

    tr {
      background: ${({ theme }) => theme.blogColors.background};

      &:nth-child(2n + 2) {
        background: transparent;
      }
    }
  }

  p {
    line-height: ${rem(24)};
  }

  .px-4 {
    padding-left: 0px;
    padding-right: 0px;
  }

  ol,
  ul,
  menu {
    list-style: inside;
  }

  iframe {
    max-width: 100%;

    ${({ theme }) => theme.mediab.m580`
      height: auto;
    `}
  }
`;

export const ConditionText = styled.div`
  color: red;
  padding-bottom: ${rem(32)};
`;

export const StyledTitle = styled.h2`
  font-size: ${rem(24)};
  margin-bottom: ${rem(32)};
  margin-top: ${rem(0)};
  font-weight: 400;
`;

export const StyledH3 = styled.h3`
  font-size: ${rem(24)};
  font-weight: 400;
`;

const FullDescription = styled(TextP)`
  margin-bottom: ${rem(48)};
`;

const Img = styled.img`
  width: 100%;
  border-radius: ${rem(4)};
`;

const StyledUl = styled.ul`
  padding-left: ${rem(20)};
  list-style-type: square;
`;

export { Description as DsiDescription };
